import { jsx } from '@emotion/react';
import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import Pattern from '../components/pattern';
import IntrinsicElements = jsx.JSX.IntrinsicElements;

interface PatternProcessorElement extends Element {
  props: Element['props'] & {
    name: string;
    styleVariation?: number;
    tagName?: keyof IntrinsicElements;
    'data-erom-pattern-name': string;
    'data-erom-style-variation'?: string;
    'data-erom-tag-name'?: keyof IntrinsicElements;
  };
}

const pattern: Processor<PatternProcessorElement> = {
  priority: 99,
  name: 'pattern',
  test: ({ node }) =>
    !!node.props?.className &&
    (node.props.className.includes('wp-block-erom-pattern') ||
      node.props.className.includes('wp-block-erom-template-part')),
  processor: ({ node }) => {
    node.props.name = node.props['data-erom-pattern-name'];
    node.props.styleVariation = parseInt(node.props['data-erom-style-variation'] ?? '0', 10);
    node.props.tagName = node.props['data-erom-tag-name'];
    node.component = Pattern as ComponentType;
    return node;
  }
};

export default pattern;
